import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ImageWrapper = styled.div`
  width: 265px;
  height: 265px;
  margin-top: ${Spacing.S40};
`

export const FeaturesTesterWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: ${Spacing.S40};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.Grey50};
`

export const FeaturesTesterQuestion = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: ${Spacing.S24};
`

export const FeaturesTesterDescription = styled.div``

export const CandidateToggleContainer = styled.div`
  width: 40px;
`
